<template>
    <form-container :headerText="title" :width="450" action="dummyVereineEdit"
                    :valid-actions="['dummyVereineEdit']" @save="save" >
        <v-text-field v-model="vereinsName" :rules="[rules.required]"
                      label="Vereinsname" class="mx-7 mb-3">
        </v-text-field>
    </form-container>
</template>

<script>
    import {db} from "../../../services/db"
    import FormContainer from "../../../components/form/formContainer";
    import {FormRules} from "../../../services/formRules";

    export default {
        components: {FormContainer},
        name: "dummy-vereine-edit",
        props: ['currentObject'],
        data: () => ({
            vereinsName: null,
            rules: null,
        }),
        computed: {
            title(){ return this.currentObject.id ? 'Verein für Testspiele ändern' :
                                                 'Verein für Testspiele anlegen'; },
            lv(){ return this.$store.state.realtime.landesverbaende['1']}
        },
        created(){
            if ( this.currentObject ) { this.vereinsName = this.currentObject.name }
            this.rules = new FormRules();
        },
        methods: {
            save(){
            // get id
                const id = this.currentObject.id ? this.currentObject.id : this.getVereinsId();
                const field = 'vereine.' + id;
                this.$store.state.local.loader = true;
            // save
                db.collection("landesverbaende").doc("1").update({
                    [field]: {name: this.vereinsName}
                })
                    .then(() => {
                        console.log("Document successfully updated!");
                        this.$store.state.local.loader = false;
                        window.history.back();
                    })
                    .catch((error) => {
                        // The document probably doesn't exist.
                        console.error("Error updating document: ", error);
                        this.$store.state.local.loader = false;
                    });
                //
            },
            getVereinsId(){
                let start = 99;
                Object.keys(this.lv.vereine).forEach( (vereinsNr) => {
                    if ( parseInt(vereinsNr) > start ) { start = parseInt(vereinsNr) }
                });
                return start + 1;
            }
        },
    }
</script>

<style scoped>

</style>